import { render, staticRenderFns } from "./ResignDialog.vue?vue&type=template&id=24851c5a&"
import script from "./ResignDialog.vue?vue&type=script&lang=js&"
export * from "./ResignDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports